import React from 'react';
import { UICheckboxVariant } from '../types';
import BaseBooleanInput, { IBaseBooleanInputProps } from '@gik/ui/BaseBooleanInput/BaseBooleanInput';
import bemBlock from '@gik/core/utils/bemBlock';
import SvgIcon from '../SvgIcon';

export interface CheckboxProps extends IBaseBooleanInputProps {
  /**
   * Style variant to use
   */
  variant?: UICheckboxVariant;

  /**
   * Put checkbox in indeterminate state
   * see https://css-tricks.com/indeterminate-checkboxes
   */
  indeterminate?: boolean;

  /**
   * A custom icon to display instead of the default checkmark.
   */
  icon?: React.ReactNode;

  /**
   * A custom icon to display instead of the default checkmark.
   */
  indeterminateIcon?: React.ReactNode;
}

/**
 * GIK Checkbox component
 */
function Checkbox(
  { indeterminate, variant = 'primary', size = 'base', icon, indeterminateIcon, ...otherProps }: CheckboxProps,
  ref: React.LegacyRef<HTMLInputElement>
): React.ReactElement {
  const bem = bemBlock('checkbox');

  const props = {
    size,
    variant,
    ...otherProps,
  };

  return (
    <BaseBooleanInput
      {...props}
      bem={bem}
      render={inputProps => (
        <div className={bem(`wrapper`)}>
          <input
            ref={ref as React.LegacyRef<HTMLInputElement>}
            indeterminate={indeterminate?.toString()}
            {...inputProps}
          />
          <div className={bem(`icon`)}>
            {!indeterminate && (icon || <SvgIcon name="Check" />)}
            {indeterminate && (indeterminateIcon || <SvgIcon name="Minus" />)}
          </div>
          <div className={bem(`border`)} />
          <div className={bem(`background`)} />
        </div>
      )}
    />
  );
}

export default React.forwardRef(Checkbox);

export const CheckboxNoRef = Checkbox;
